import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, ResolveEnd, Router } from '@angular/router';
import { filter, first, throttle } from 'rxjs/operators';
import { PageTurnService } from './services/analytics/page-turn.service';
import { TimePerPageService } from './services/analytics/time-per-page.service';
import { fromEvent, interval, merge } from 'rxjs';
import { PortalTimeoutService } from './shared/services/portal-timeout/portal-timeout.service';
import { Title } from '@angular/platform-browser';
import { PolicyService } from './services/policy/policy.service';

const USER_ACTIVITY_EVENTS = ['click', 'keypress'];
const THROTTLE_TIME = 2 * 60 * 1000; // two minutes

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private timePerPageService: TimePerPageService,
    private pageTurnService: PageTurnService,
    private timeoutService: PortalTimeoutService,
    private titleService: Title,
    private policytService: PolicyService
  ) {}

  Symetra = "Symetra";

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.pageTurnService.startNavigation();
      }
      if (event instanceof ResolveEnd) {
        this.updateTabTitle(event);
      }
      if (event instanceof NavigationCancel) {
        this.pageTurnService.stopNavigation(event);
      }

      if (event instanceof NavigationEnd) {
        this.pageTurnService.stopNavigation(event);
        this.timePerPageService.onPageChange(event);
      }
    });

    const eventStreams = USER_ACTIVITY_EVENTS.map((ev) => fromEvent(window, ev));
    const allEvents$ = merge(...eventStreams).pipe(throttle(() => interval(THROTTLE_TIME)));
    allEvents$.subscribe(() => {
      this.timeoutService.refreshServerSession();
    });

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        first()
      )
      .subscribe(() => {
        const spinner = window.document.getElementById('app-load-spinner');
        if (spinner) {
          // workaround - Element.prototype.remove does not exist in IE
          spinner.parentNode?.removeChild(spinner);
        }
      });
  }

  private updateTabTitle(event: ResolveEnd): void {
    const snapshot = event.state.root.root;
    let child = snapshot.firstChild;
    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
      } else if (child.data && child.data.title) {
          this.titleService.setTitle(`${this.Symetra} | ${child.data.title}`);
        break;
      } else if (child.data && child.data.pageHeader) {
          this.titleService.setTitle(`${this.Symetra} | ${child.data.pageHeader}`);
        break;
      } 
        else {
          this.titleService.setTitle(`${this.Symetra} | Search for groups`);
        break;
      }
    }
  }
}
